import { render, staticRenderFns } from "./reset-password-box.vue?vue&type=template&id=14b9cee7"
import script from "./reset-password-box.vue?vue&type=script&lang=js"
export * from "./reset-password-box.vue?vue&type=script&lang=js"
import style0 from "./reset-password-box.vue?vue&type=style&index=0&id=14b9cee7&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../Shield.UI.ProductManagementSystemWebsite/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports